import customFeatures from './customFeatures.json';
import brandOverrides from './brandOverrides.json';
import registrationGate from './registrationGate.json';
import { deepMerge } from '../../deepMerge';

export default deepMerge(customFeatures, brandOverrides, registrationGate);
